import dynamic from 'next/dynamic'

export const BusinessFinancing = {
    Hero: dynamic(() => import('./Hero')),
    Quote: dynamic(() => import('./Quote')),
    CTA: dynamic(() => import('./CTA')),
    FinancingTable: dynamic(() => import('./FinancingTable')),
    HowToApply: dynamic(() => import('./HowToApply')),
}
